const COLORS = {
  info: 'darkturquoise',
  warning: 'coral',
  error: 'crimson',
};

const ENV = window.__RUNTIME_CONFIG__.NODE_ENV;
const isDev = ENV === 'development';

export default class Logger {
  static log(message, color = COLORS.info) {
    if (!isDev) return;
    this.env();
    console.log(`%c ${message}`, `color: ${color};`);
  }

  static info(message) {
    this.log(message, COLORS.info);
  }

  static warning(message) {
    this.log(message, COLORS.warning);
  }

  static error(message) {
    this.log(message, COLORS.error);
  }

  static table(args) {
    if (!isDev) return;
    this.env();
    console.table(args);
  }

  static env() {
    console.log(`ENV: ${ENV}`);
  }
}
